module.exports = __webpack_public_path__ + "static/media/Group4.fef1abd4.png";